import React from 'react';
const control = 'w-full rounded-xl border border-line bg-surface2/70 px-3.5 text-sm text-white placeholder:text-mist/70 transition-[border-color,background-color,box-shadow] duration-150 ease-smooth hover:border-neon/40 focus:border-neon focus:bg-surface2 focus:shadow-[0_0_0_3px_rgba(31,123,255,0.18)] focus:outline-none';
export function Label({
  htmlFor,
  children
}: {
  htmlFor: string;
  children: React.ReactNode;
}) {
  return <label htmlFor={htmlFor} className="mb-1.5 block text-[12px] font-semibold uppercase tracking-wide text-mist" data-id="element-407" data-mp="917tpsm7fy34">
      {children}
    </label>;
}
interface FieldBase {
  id: string;
  label: string;
  required?: boolean;
  className?: string;
}
export function TextField({
  id,
  label,
  required,
  className,
  ...rest
}: FieldBase & React.InputHTMLAttributes<HTMLInputElement>) {
  return <div className={className} data-id="element-408" data-mp="rpv0cfk14vit">
      <Label htmlFor={id} data-id="element-409" data-mp="wqiyrmal8en2">
        {label}
        {required ? ' *' : ''}
      </Label>
      <input id={id} name={id} required={required} className={`${control} h-11`} {...rest} data-id="element-410" data-mp="yb65xr7eoqag" />
    </div>;
}
export function SelectField({
  id,
  label,
  required,
  className,
  options,
  placeholder,
  ...rest
}: FieldBase & {
  options: string[];
  placeholder?: string;
} & React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <div className={className} data-id="element-411" data-mp="kczrxvlz3l1p">
      <Label htmlFor={id} data-id="element-412" data-mp="kdrdseprq4es">
        {label}
        {required ? ' *' : ''}
      </Label>
      <select id={id} name={id} required={required} className={`${control} h-11`} {...rest} data-id="element-413" data-mp="1h15qc0saxh7j">
        <option value="" data-id="element-414" data-mp="1c3dwv2c0dn18">{placeholder ?? 'Seleccionar'}</option>
        {options.map(o => <option key={o} value={o} data-id="element-415" data-mp="17akweqnkp0uy">
            {o}
          </option>)}
      </select>
    </div>;
}
export function TextAreaField({
  id,
  label,
  required,
  className,
  ...rest
}: FieldBase & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <div className={className} data-id="element-416" data-mp="1v1glhg0n9hyi">
      <Label htmlFor={id} data-id="element-417" data-mp="1v0f5qy8oo7ag">
        {label}
        {required ? ' *' : ''}
      </Label>
      <textarea id={id} name={id} required={required} rows={4} className={`${control} py-3 resize-y`} {...rest} data-id="element-418" data-mp="3pa2ibmvmkvka" />
    </div>;
}
export function CheckboxField({
  id,
  label,
  checked,
  onChange
}: {
  id: string;
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return <label htmlFor={id} className="flex cursor-pointer items-center gap-2.5 text-sm text-white/90" data-id="element-419" data-mp="36jcgm1hsjet0">
      <input id={id} name={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="h-4 w-4 rounded border-line bg-surface2 text-neon accent-neon" data-id="element-420" data-mp="3bifhd9qqmyv6" />
      {label}
    </label>;
}